import Container from "@components/common/Container";
import MinimalFooter from "@components/common/MinimalFooter";
import usePartnerContext from "@lib/hooks/usePartnerContext";
import clsx from "clsx";
import { FC, PropsWithChildren } from "react";
import ApplicationHeader from "../SplitLayout/ApplicationHeader";

const ApplicationLayout: FC<
  PropsWithChildren<{
    border?: boolean;
    centered?: boolean;
    className?: string;
  }>
> = ({ children, border, className, centered = true }) => {
  const { partner } = usePartnerContext();
  return (
    <div className="flex flex-col min-h-screen">
      <ApplicationHeader border={border} />
      <Container
        padding
        className={clsx(
          centered ? "grow flex m:items-center" : "grow",
          className,
        )}
      >
        {children}
      </Container>
      <MinimalFooter isPartner={!!partner} isFullWidth />
    </div>
  );
};

export default ApplicationLayout;
